'use client'

import { PageInfo } from '@/types'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
export default function Pagination({
  setPage,
  pageInfo,
}: {
  setPage: any
  pageInfo: PageInfo
}) {
  const handleUpdatePage = (page: number) => {
    setPage(page)
  }
  const pathname = usePathname()
  const [basePath] = pathname.split('/pages/')

  return (
    <ul className="flex justify-center items-center text-sm font-medium">
      {pageInfo.hasPreviousPage ? (
        <li className="flex justify-center items-center w-10 h-10 cursor-pointer mx-1">
          <Link
            className="group px-1 hover:text-blue_400"
            href={`${basePath}/pages/${pageInfo.currentPage - 1}`}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  className="fill-[#000000] transition-all duration-300 group-hover:fill-[#6E95FF]"
                  d="M7.83594 15.3414L0.5 8.00549L7.84924 0.65625L9.01032 1.809L3.62893 7.19042H20.5V8.82055H3.62893L8.99702 14.1886L7.83594 15.3414Z"
                  fill="black"
                />
              </svg>
            </div>
          </Link>
        </li>
      ) : (
        <li className="flex justify-center items-center w-10 h-10 mx-1">
          <a
            className="px-1 pointer-events-none"
            onClick={() => handleUpdatePage(pageInfo.currentPage - 1)}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  className="fill-[#AAB4C0]"
                  d="M7.83594 15.3414L0.5 8.00549L7.84924 0.65625L9.01032 1.809L3.62893 7.19042H20.5V8.82055H3.62893L8.99702 14.1886L7.83594 15.3414Z"
                  fill="black"
                />
              </svg>
            </div>
          </a>
        </li>
      )}
      {Array.from({ length: pageInfo.totalPages }, (_, i) => {
        if (
          (pageInfo.currentPage - 2 <= i + 1 &&
            i + 1 <= pageInfo.currentPage + 2) ||
          i + 1 == 1 ||
          i + 1 == pageInfo.totalPages
        ) {
          return (
            <li
              key={i}
              className={
                i + 1 === pageInfo.currentPage
                  ? 'flex justify-center items-center bg-blue_400 text-white mx-1 w-10 h-10 text-[16px] rounded-full'
                  : 'flex justify-center items-center w-10 h-10 text-[16px] cursor-pointer mx-1'
              }
            >
              <Link
                href={`${basePath}/pages/${i + 1}`}
                className={
                  i + 1 === pageInfo.currentPage
                    ? 'px-1'
                    : 'px-1 cursor-pointer transition-colors duration-300 hover:text-blue_400'
                }
              >
                {i + 1}
              </Link>
            </li>
          )
        } else if (
          i + 1 == pageInfo.currentPage - 3 ||
          i + 1 == pageInfo.currentPage + 3
        ) {
          return <li key={i}>...</li>
        }
      })}

      {pageInfo.hasNextPage ? (
        <li className="flex justify-center items-center w-10 h-10 cursor-pointer mx-1 -rotate-180">
          <Link
            className="px-1 hover:text-blue_400 group"
            href={`${basePath}/pages/${pageInfo.currentPage + 1}`}
          >
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  className="fill-[#000000] transition-all duration-300 group-hover:fill-[#6E95FF]"
                  d="M7.83594 15.3414L0.5 8.00549L7.84924 0.65625L9.01032 1.809L3.62893 7.19042H20.5V8.82055H3.62893L8.99702 14.1886L7.83594 15.3414Z"
                  fill="black"
                />
              </svg>
            </div>
          </Link>
        </li>
      ) : (
        <li className="flex justify-center items-center w-10 h-10 mx-1 -rotate-180">
          <a className="px-1 pointer-events-none">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  className="fill-[#AAB4C0]"
                  d="M7.83594 15.3414L0.5 8.00549L7.84924 0.65625L9.01032 1.809L3.62893 7.19042H20.5V8.82055H3.62893L8.99702 14.1886L7.83594 15.3414Z"
                  fill="black"
                />
              </svg>
            </div>
          </a>
        </li>
      )}
    </ul>
  )
}
